import createLucideIcon from '../createLucideIcon';

const MinusCircle = createLucideIcon('MinusCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '8', y1: '12', x2: '16', y2: '12', key: '1myapg' }],
]);

export default MinusCircle;
